import * as Sentry from '@sentry/react';

export function initSentry() {
  Sentry.init({
    dsn: 'https://9ca6ed9830e5a440e0d4930b05d1b5b7@o332878.ingest.us.sentry.io/4510657766686720',
    environment: 'production',
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    release: '0.0.3',
  });
}
